import usePrimeTrialPromoModalStore from './store';
import { PrimePitchOpenOptions, PrimeTrialPromoContextualId } from './types';

export default function usePrimeTrialPromoModal() {
  const open = usePrimeTrialPromoModalStore((state) => state.open);
  const loading = usePrimeTrialPromoModalStore((state) => state.loading);
  const error = usePrimeTrialPromoModalStore((state) => state.error);
  const data = usePrimeTrialPromoModalStore((state) => state.data);

  const openModal = usePrimeTrialPromoModalStore((state) => state.openModal);
  const closeModal = usePrimeTrialPromoModalStore((state) => state.closeModal);
  const joinPrime = usePrimeTrialPromoModalStore((state) => state.joinPrime);

  return {
    open,
    loading,
    error,
    data,

    openPrimeTrialPromoModal: (
      contextId: PrimeTrialPromoContextualId,
      goalUID: string,
      goalSlug: string,
      options?: PrimePitchOpenOptions
    ) => openModal(contextId, goalUID, goalSlug, options),

    closePrimeTrialPromoModal: closeModal,
    joinPrime
  };
}
